export default (action) => {
  const meta = action.meta || {};

  Object.assign(meta, { suppressGlobalErrors: true });

  action.meta = meta;

  return action;
};
